import gql from 'graphql-tag'

export const CreateProjectDefectivenessReportJob = gql`
  mutation createProjectDefectivenessReport($project_id: Int!, $type: String!, $args: String!) {
    createJobs(project_id: $project_id, type: $type, args: $args) {
      job {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Report/mutations.js